// extracted by mini-css-extract-plugin
export default {"pattern":"landingPage_pattern__lHqt4","pattern1":"landingPage_pattern1__M0iTb"};